import { objectToQueryString } from "../helpers/ApiHelper";
import { IContractAreaResponse, IContractAreaSearchParams } from "../models/IContractArea";
import * as Utils from "../utils/Config";
import { ApiClient, IPaginatedResponse } from "./ApiClient";

export class ContractAreaApi extends ApiClient {

    getOrganisationContractAreas(searchParams: IContractAreaSearchParams, success: (data: IPaginatedResponse<IContractAreaResponse>) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IContractAreaResponse>(`${Utils.MEN_PORTAL_API_BASE_URL}/contractAreas/searchContractAreas?${queryString}`, success, undefined, final);
    }
}
